(function() {
    function openPopup(html, additionalClass) {

        const popup = $(`
            <div class="div24Popup" style="display: none;">
                <div class="box24Background"></div>
                <div class="box24Content c24Editor">
                </div>
            </div>
        `);

        $('body').prepend(popup);

        const content = popup.children('.box24Content');

        content.removeClass('fixed');

        if (additionalClass) {
            content.addClass(additionalClass);
        }

        if (!popup.children('.ico24Close').length) {
            popup.append('<div class="ico24Close"></div>');
        }

        content.html(html);

        $('.div24Popup .box24Background, .div24Popup .ico24Close, .div24Popup .js24CloseTooltip').click(function() {
            $('.div24Popup').hide();
            $('body').removeClass('c24Fixed');
            $('html').removeClass('c24Fixed');
            popup.remove();
        });

        const tablesaws = $('.tablesaw', content);
        if (tablesaws.length > 0) {
            tablesaws.prev('.tablesaw-bar').find('.tablesaw-advance').remove();
            tablesaws.table('refresh');
        }

        $('html').addClass('c24Fixed');
        $('body').addClass('c24Fixed');
        popup.show();

        const contentTop = Math.max(70, ($(window).height() - content.height()) / 4);

        content.css({
            '--popupTopDistance': contentTop + 'px',
        });

        $('.ico24Close', popup).css({
            top: contentTop - 30,
        });
    }

    window.c24LpOpenPopup = openPopup;

    $(document).ready(function() {
        $('.c24Tooltip, .c24TooltipImage').on('click', function() {
            openPopup($('#' + $(this).data('content-id')).html());
        });

        $('.js24TeaserPointer').on('click', function(event) {
            const target = $(event.target);

            let tooltip = $('.js24Tooltip', target);

            if (tooltip.length === 0) {
                tooltip = $('.js24Tooltip', target.closest('.box24Teaser'));
            }
            if (tooltip.length === 0) {
                tooltip = $('.js24Tooltip', target.closest('.js24TeaserPointer'));
            }

            if (tooltip.length === 0) {
                return;
            }

            openPopup(tooltip.html(), tooltip.data('position'));
        });
    });

})();
